export default __webpack_public_path__ + "static/mxp-icons-a36f9cb632ea5599a7ad78c6f06522fe.svg";